import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RollOffDumpsterRentalsPage = lazy(() => import('../pages/roll-off-dumpster-rentals/page'));
const JunkRemovalPage = lazy(() => import('../pages/junk-removal/page'));
const EvictionCleanOutPage = lazy(() => import('../pages/eviction-clean-out/page'));
const DumpsterRentalsPage = lazy(() => import('../pages/dumpster-rentals/page'));
const DistressedHomeReadyPage = lazy(() => import('../pages/distressed-home-ready/page'));
const TrashTalkPage = lazy(() => import('../pages/trash-talk/page'));
const HoardingCleanupPage = lazy(() => import('../pages/hoarding-cleanup/page'));
const DumpsterSizeGuidePage = lazy(() => import('../pages/trash-talk/dumpster-size-guide/page'));
const SpringCleaningGuidePage = lazy(() => import('../pages/trash-talk/spring-cleaning-guide/page'));
const ConstructionDebrisDisposalPage = lazy(() => import('../pages/trash-talk/construction-debris-disposal/page'));
const CommercialWasteManagementPage = lazy(() => import('../pages/trash-talk/commercial-waste-management/page'));
const EcoFriendlyWasteDisposalPage = lazy(() => import('../pages/trash-talk/eco-friendly-waste-disposal/page'));
const LandlordPropertyCleanoutPage = lazy(() => import('../pages/trash-talk/landlord-property-cleanout/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

import IllegalDumpingGuidePage from '../pages/trash-talk/illegal-dumping-guide/page';
import AdoptAHighwayElPasoPage from '../pages/trash-talk/adopt-a-highway-el-paso/page';
import RollOffDumpsterAnatomyPage from '../pages/trash-talk/roll-off-dumpster-anatomy/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/roll-off-dumpster-rentals',
    element: <RollOffDumpsterRentalsPage />,
  },
  {
    path: '/junk-removal',
    element: <JunkRemovalPage />,
  },
  {
    path: '/eviction-clean-out',
    element: <EvictionCleanOutPage />,
  },
  {
    path: '/dumpster-rentals',
    element: <DumpsterRentalsPage />,
  },
  {
    path: '/distressed-home-ready',
    element: <DistressedHomeReadyPage />,
  },
  {
    path: '/trash-talk',
    element: <TrashTalkPage />,
  },
  {
    path: '/trash-talk/choosing-right-dumpster-size-el-paso',
    element: <DumpsterSizeGuidePage />,
  },
  {
    path: '/trash-talk/spring-cleaning-declutter-home-el-paso',
    element: <SpringCleaningGuidePage />,
  },
  {
    path: '/trash-talk/construction-waste-management-el-paso',
    element: <ConstructionDebrisDisposalPage />,
  },
  {
    path: '/trash-talk/dumpster-disposal-guidelines-el-paso',
    element: <CommercialWasteManagementPage />,
  },
  {
    path: '/trash-talk/eco-friendly-waste-disposal-el-paso',
    element: <EcoFriendlyWasteDisposalPage />,
  },
  {
    path: '/trash-talk/landlord-property-cleanout-guide-el-paso',
    element: <LandlordPropertyCleanoutPage />,
  },
  {
    path: '/trash-talk/illegal-dumping-guide',
    element: <IllegalDumpingGuidePage />,
  },
  {
    path: '/trash-talk/adopt-a-highway-el-paso',
    element: <AdoptAHighwayElPasoPage />,
  },
  {
    path: '/trash-talk/roll-off-dumpster-anatomy',
    element: <RollOffDumpsterAnatomyPage />,
  },
  {
    path: '/hoarding-cleanup',
    element: <HoardingCleanupPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
